import { render } from "./SidebarMenuLayout.vue?vue&type=template&id=14297e61&scoped=true"
import script from "./SidebarMenuLayout.vue?vue&type=script&lang=js"
export * from "./SidebarMenuLayout.vue?vue&type=script&lang=js"

import "./SidebarMenuLayout.vue?vue&type=style&index=0&id=14297e61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14297e61"]])

export default __exports__